var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPortofolioBanner(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2434.912,
    height: 915.54,
    viewBox: "0 0 2434.912 915.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_475",
    "data-name": "Group 475",
    transform: "translate(410.607 -2720.861) rotate(3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M-3408.823,3043.339c249.9-110.326,674.143-186.275,674.143-186.275S-1745.3,2704.212-1500.5,2721.876c480.93,34.7-25.478,454.5-25.478,454.5s-199.333,136.948-371.336,136.948-132.02-121.459-416.429-72.423S-2700,3491.364-3034.952,3509.47s-525.141-79.611-618.608-196.144S-3658.718,3153.666-3408.823,3043.339Z",
    transform: "translate(3463.661 16)",
    fill: "#eda751"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Circles_and_lines",
    "data-name": "Circles and lines",
    transform: "translate(-79.881 3254.664) rotate(-62)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_57",
    "data-name": "Ellipse 57",
    transform: "translate(35 501)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    transform: "translate(444 698)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_58",
    "data-name": "Ellipse 58",
    transform: "translate(206 611)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    transform: "translate(225 535)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    transform: "translate(51 174)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_59",
    "data-name": "Ellipse 59",
    transform: "translate(259 754)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_82",
    "data-name": "Line 82",
    x2: 18,
    y2: 20,
    transform: "translate(115.5 520.5)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_85",
    "data-name": "Line 85",
    x1: 17,
    y2: 15,
    transform: "translate(107.5 48.5)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M0,0-11.356,27.29",
    transform: "translate(76.5 716.5)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M-11.356,0,5.307,24.232",
    transform: "translate(587.837 790.558)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_84",
    "data-name": "Line 84",
    x2: 22,
    y2: 6,
    transform: "translate(54.5 292.5)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_86",
    "data-name": "Line 86",
    x1: 16,
    y2: 19.5,
    transform: "translate(376.5 611)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Circles_and_lines-2",
    "data-name": "Circles and lines",
    transform: "translate(1886.181 3528.178) rotate(179)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_57-2",
    "data-name": "Ellipse 57",
    transform: "translate(35 501)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_62-2",
    "data-name": "Ellipse 62",
    transform: "translate(444 698)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_58-2",
    "data-name": "Ellipse 58",
    transform: "translate(206 611)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_60-2",
    "data-name": "Ellipse 60",
    transform: "translate(225 535)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_61-2",
    "data-name": "Ellipse 61",
    transform: "translate(51 174)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_59-2",
    "data-name": "Ellipse 59",
    transform: "translate(259 754)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_82-2",
    "data-name": "Line 82",
    x2: 18,
    y2: 20,
    transform: "translate(115.5 520.5)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125-2",
    "data-name": "Path 1125",
    d: "M0,0-11.356,27.29",
    transform: "translate(76.5 716.5)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126-2",
    "data-name": "Path 1126",
    d: "M-11.356,0,5.307,24.232",
    transform: "translate(587.837 790.558)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_84-2",
    "data-name": "Line 84",
    x2: 22,
    y2: 6,
    transform: "translate(54.5 292.5)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_86-2",
    "data-name": "Line 86",
    x1: 16,
    y2: 19.5,
    transform: "translate(376.5 611)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortofolioBanner);
export default __webpack_public_path__ + "static/media/portofolioBanner.f7da5adcd9d36e28386c0f1322bdc96e.svg";
export { ForwardRef as ReactComponent };